// Главный файл экспорта всех MST сторов
import { RootStore } from './mst/RootStore.js';

// Создаем синглтон экземпляр стора
let rootStore = null;

export function createRootStore() {
    if (!rootStore) {
        rootStore = RootStore.create({});
    }
    return rootStore;
}

export function getRootStore() {
    if (!rootStore) {
        rootStore = createRootStore();
    }
    return rootStore;
}

// Экспортируем инстанс для использования в компонентах
const store = getRootStore();
export { store as rootStore };

// Экспорт типа для TypeScript/документации
export { RootStore };

// Экспорт отдельных сторов для прямого доступа (если нужно)
export { UIStore } from './mst/UIStore.js';
export { AuthStore } from './mst/AuthStore.js';
export { MSTModelStore } from './mst/MSTModelStore.js';

// Для отладки в консоли браузера
if (import.meta.env.DEV) {
    window.rootStore = rootStore;
}